<span *ngIf="isVisible">
  <span [ngSwitch]="!!opportunity.value">
    <span *ngSwitchCase="false">
      Loading...
    </span>
    <span *ngSwitchCase="true" [title]="tooltipText">
      <button class="btn {{btnClass}} {{submitted ? 'btn-success' : 'btn-primary'}}" (click)="submit()"
      [ngSwitch]="submitted"
      [disabled]="isDisabled">
        <ng-container *ngSwitchCase="true">
          <i *ngIf="config.submittedIconClass" [class]="config.submittedIconClass"></i>
          {{config.submittedText}}
        </ng-container>
        <ng-container *ngSwitchCase="false">
          <i *ngIf="config.toSubmitIconClass" [class]="config.toSubmitIconClass"></i>
          {{config.toSubmitText}}
        </ng-container>
      </button>
    </span>
  </span>
</span>